import dayjs from "dayjs";

import { shortMonthAndFullDay, shortMonthDayAndYear } from "@similarweb/pro-logic-components";

export const getFormattedDuration = (date: string) => {
    const from = dayjs(date);
    const to = from.add(6, "day");

    return `${from.format(shortMonthAndFullDay)} - ${to.format(shortMonthDayAndYear)}`;
};
